/*
 * Generated from Symbol.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated. All rights reserved.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
export default {
  name: 'Symbol',
  bbox: [-180, -293, 1090, 1010],
  ascender: 0,
  descender: 0,
  xHeight: 0,
  capHeight: 0,
  glyphNames:
    'space exclam numbersign percent ampersand parenleft parenright plus comma period slash zero one two three four five six seven eight nine colon semicolon less equal greater question bracketleft bracketright underscore braceleft bar braceright Euro florin ellipsis bullet logicalnot degree plusminus mu multiply divide',
  glyphWidths: [
    250, 333, 500, 833, 778, 333, 333, 549, 250, 250, 278, 500, 500, 500, 500,
    500, 500, 500, 500, 500, 500, 278, 278, 549, 549, 549, 444, 333, 333, 500,
    480, 200, 480, 750, 500, 1000, 460, 713, 400, 549, 576, 549, 549,
  ],
  kernPairs: [],
};
